import { FILE_ATTACHMENTS_CONSTANTS } from "../../../constants";
import { FormStateType } from "../../../../types";

export const formFieldsState: FormStateType = {
  [FILE_ATTACHMENTS_CONSTANTS.COMMERCIAL_INVOICE]: {
    value: [],
    hidden: false,
    errors: [],
  },
  [FILE_ATTACHMENTS_CONSTANTS.BILL_OF_LADING_FRONT]: {
    value: [],
    hidden: false,
    errors: [],
  },
  [FILE_ATTACHMENTS_CONSTANTS.BILL_OF_LADING_REVERSE]: {
    value: [],
    hidden: false,
    errors: [],
  },
  [FILE_ATTACHMENTS_CONSTANTS.PACKING_SLIP]: {
    value: [],
    hidden: false,
    errors: [],
  },
  [FILE_ATTACHMENTS_CONSTANTS.DAMAGED_PACKAGING_PHOTOS]: {
    value: [],
    hidden: false,
    errors: [],
  },
  [FILE_ATTACHMENTS_CONSTANTS.DAMAGED_CONTENTS_PHOTOS]: {
    value: [],
    hidden: false,
    errors: [],
  },
  [FILE_ATTACHMENTS_CONSTANTS.PROOF_OF_DELIVERY]: {
    value: [],
    hidden: false,
    errors: [],
  },
  [FILE_ATTACHMENTS_CONSTANTS.PROOF_FROM_CARRIER]: {
    value: [],
    hidden: false,
    errors: [],
  },
  [FILE_ATTACHMENTS_CONSTANTS.POLICE_REPORT]: {
    value: [],
    hidden: false,
    errors: [],
  },
  [FILE_ATTACHMENTS_CONSTANTS.ADDITIONAL_DOCUMENTS]: {
    value: [],
    hidden: false,
    errors: [],
  },
};
